import React from 'react';
import { FormattedMessage } from 'react-intl';
import replaceSpaceWithHyphen from '../../utils/replaceSpaceWithHyphen';

import {
  StyledContent,
  List,
  StyledLabel,
  CheckBox,
  Only,
  ChildWrapper,
  ChildElement,
  HoverWrapper
} from './Styles';

const ContentWithChild = ({
  list,
  dirtyList,
  toggleCheckBoxParent,
  toggleCheckBox,
  selectOnly,
  isDirty,
  compareFn,
  shouldNotTranslate,
  testId
}) => {
  return (
    <StyledContent data-testid={`${testId}-child`}>
      {!isDirty &&
        Object.keys(list)
          .sort(compareFn)
          .map(id => {
            return (
              <List key={id} variant="nested">
                <CheckBox
                  checked={list[id].isSelected}
                  onChange={e => toggleCheckBoxParent(e, id)}
                  data-testid={replaceSpaceWithHyphen(list[id].displayName)}
                />
                <StyledLabel className={shouldNotTranslate && 'notranslate'}>
                  {list[id].displayName}
                </StyledLabel>
                {list[id].children.length > 0 && (
                  <ChildWrapper>
                    {list[id].children.map((child, childIndex) => {
                      return (
                        <ChildElement key={child.displayName}>
                          <HoverWrapper>
                            <CheckBox
                              checked={child.isSelected}
                              onChange={e => toggleCheckBox(e, id, childIndex)}
                              data-testid={replaceSpaceWithHyphen(
                                `${list[id].displayName}-${child.displayName}`
                              )}
                            />
                            <div
                              className={shouldNotTranslate && 'notranslate'}
                            >
                              {child.displayName}
                            </div>
                            <Only onClick={e => selectOnly(e, id, childIndex)}>
                              <FormattedMessage id="list.filters.only" />
                            </Only>
                          </HoverWrapper>
                        </ChildElement>
                      );
                    })}
                  </ChildWrapper>
                )}
              </List>
            );
          })}

      {isDirty &&
        Object.keys(dirtyList)
          .sort(compareFn)
          .map(id => {
            return (
              <List key={id}>
                <CheckBox
                  checked={dirtyList[id].isSelected}
                  onChange={e => toggleCheckBoxParent(e, id)}
                  data-testid={replaceSpaceWithHyphen(
                    dirtyList[id].displayName
                  )}
                />
                <StyledLabel>{dirtyList[id].displayName}</StyledLabel>
                {dirtyList[id].children.length > 0 && (
                  <ChildWrapper>
                    {dirtyList[id].children.map((child, childIndex) => {
                      return (
                        <ChildElement key={child.displayName}>
                          <HoverWrapper>
                            <CheckBox
                              checked={child.isSelected}
                              onChange={e => toggleCheckBox(e, id, childIndex)}
                              data-testid={replaceSpaceWithHyphen(
                                `${dirtyList[id].displayName}-${child.displayName}`
                              )}
                            />
                            <div>{child.displayName}</div>
                            <Only onClick={e => selectOnly(e, id, childIndex)}>
                              <FormattedMessage id="list.filters.only" />
                            </Only>
                          </HoverWrapper>
                        </ChildElement>
                      );
                    })}
                  </ChildWrapper>
                )}
              </List>
            );
          })}
    </StyledContent>
  );
};

export default ContentWithChild;
